import { Props } from './types';
import * as Styled from './styled';
import { useField } from 'formik';

function Radio({ label, className, ...props }: Props) {
  const [field] = useField(props);

  return (
    <Styled.Wrapper className={className}>
      <Styled.Radio
        type="radio"
        id={String(props.value)}
        value={props.value}
        {...field}
        {...props}
      />
      <Styled.Label htmlFor={String(props.value)}>{label}</Styled.Label>
    </Styled.Wrapper>
  );
}

export default Radio;
